import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  Response,
  RequestOptions,
  URLSearchParams,
} from "@angular/http";
import "rxjs/add/operator/timeout";
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Rx";
import { baseUrl } from "./constants";
import { Router } from "@angular/router";
import { Observer } from "rxjs/Observer";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { NotificationsService } from "angular2-notifications";
import * as constants from "../app.constants";

@Injectable()
export class AdminService {
  private headers = new Headers({ "Content-Type": "application/json" });

  constructor(
    private http: Http,
    private router: Router,
    public slimLoadingBarService: SlimLoadingBarService,
    public _notificationsService: NotificationsService
  ) {}

  public getCall(url, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaderOnly() : {};
    return new Promise((resolve, reject) => {
      this.http
        .get(url, { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              reject(err);
            }
          }
        );
    });
  }

  public postCall(url, params, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaders() : this.getHeaders();
    return new Promise((resolve, reject) => {
      return this.http
        .post(url, JSON.stringify(params), { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public patchCall(url, params, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaders() : this.getHeaders();
    return new Promise((resolve, reject) => {
      return this.http
        .patch(url, JSON.stringify(params), { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public deleteCall(url, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaders() : this.getHeaders();
    return new Promise((resolve, reject) => {
      return this.http
        .delete(url, { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }
  public myPutCall(url, params, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaders() : this.getHeaders();
    return new Promise((resolve, reject) => {
      return this.http
        .put(url, JSON.stringify(params), { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public putCall(url, params, auth): Promise<any> {
    this.startLoading();
    let headers: any;
    headers = auth ? this.getAuthHeaders() : this.getHeaders();
    return new Promise((resolve, reject) => {
      return this.http
        .put(url, JSON.stringify(params), { headers: headers })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public uploadImages(url, data) {
    let headersWithAuth: any = this.getAuthHeaderOnly();
    return this.http
      .post(url, data, { headers: headersWithAuth })
      .toPromise()
      .then((res) => res.json());
    // .catch(this.handleError);
  }

  public markTicketFake(url, params, auth): Promise<any> {
    this.startLoading();
    let headersWithAuth: any;
    headersWithAuth = auth ? this.getAuthHeaders() : {};
    return new Promise((resolve, reject) => {
      return this.http
        .put(url, JSON.stringify(params), { headers: headersWithAuth })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res)
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public approveRejectTicket(url, params, auth): Promise<any> {
    this.startLoading();
    let headersWithAuth: any;
    headersWithAuth = auth ? this.getAuthHeaders() : {};
    return new Promise((resolve, reject) => {
      return this.http
        .put(url, JSON.stringify(params), { headers: headersWithAuth })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res)
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public cancelTicket(url, auth): Promise<any> {
    this.startLoading();
    let headersWithAuth: any;
    headersWithAuth = auth ? this.getAuthHeaderOnly() : {};
    return new Promise((resolve, reject) => {
      return this.http
        .delete(url, { headers: headersWithAuth })
        .timeout(constants.REQ_TIMEOUT)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.completeLoading();
            resolve(data);
          },
          (err) => {
            this.completeLoading();
            if (err.status == 401 || err.status == 403) {
              this.delete();
            } else {
              // alert('Internal Server Error');
              reject(err);
            }
          }
        );
    });
  }

  public getAuthHeaderOnly() {
    let authString = localStorage.getItem("accessToken");
    let headers = {};
    headers["Authorization"] = "Token " + authString;
    return headers;
  }

  public getAuthHeaders() {
    let authString = localStorage.getItem("accessToken");
    let headers = this.getHeaders();
    headers["Authorization"] = "Token " + authString;
    return headers;
  }

  public getHeaders() {
    let headers = { "Content-Type": "application/json" };
    return headers;
  }

  public delete() {
    this.showErrorToast(constants.messages.unauthorizedRequest);
    // Cookie.deleteAll();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate([""]);
  }

  public startLoading() {
    this.slimLoadingBarService.start();
  }

  public stopLoading() {
    this.slimLoadingBarService.stop();
  }

  public completeLoading() {
    this.slimLoadingBarService.complete();
  }

  public showSuccessToast(message) {
    this._notificationsService.success(
      "Success",
      message,
      constants.successNotificationOptions
    );
  }

  public showErrorToast(message) {
    this._notificationsService.error(
      "Error",
      message,
      constants.errorNotificationOptions
    );
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/service/admin.service.ts